/* @flow */

import React from 'react';
import FontAwesome from 'react-fontawesome';
import PropTypes from '../util/prop_types';
import { keyCodes } from '../util/keycodes';

export default class OmniboxSuggestionItem extends React.Component {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    icon: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onSelection: PropTypes.func.isRequired
  }

  componentDidMount() {
    if(this.props.isActive) {
      this.elm.focus();
    }
  }

  componentDidUpdate() {
    if(this.props.isActive) {
      this.elm.focus();
    }
  }

  onKeyUp = (e) => {
    if(e.keyCode == keyCodes.enter) {
      this.props.onSelection();
    }
  }

  render(): ?React.Element<any> {
    const { props } = this;

    return (
      <li
        className="search-suggestion"
        tabIndex={props.isActive ? "0" : "-1"}
        onClick={props.onSelection}
        onKeyUp={this.onKeyUp}
        ref={(elm) => { this.elm = elm; }}>
          <div className="search-suggestion-icon">
            <FontAwesome
              name={props.icon}
              fixedWidth
              ariaLabel= {props.name}/>
          </div>
          <div className="search-suggestion-name" role="option">
            {props.name}
          </div>
      </li>
    );
  }

}
